import { render, staticRenderFns } from "./NarrativeSelector.vue?vue&type=template&id=903af77a&"
import script from "./NarrativeSelector.vue?vue&type=script&lang=js&"
export * from "./NarrativeSelector.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeSelector.vue?vue&type=style&index=0&id=903af77a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports